import React, { useContext } from 'react';
import { LanguageContext } from '../App';
import { LiveDashboard } from '../components/dashboard/LiveDashboard';
import { motion } from 'framer-motion';
import { pageTransition, slideUp } from '../utils/animations';
export const Dashboard: React.FC = () => {
  const {
    language
  } = useContext(LanguageContext);
  return <motion.div className="pb-16 md:pb-6" variants={pageTransition} initial="hidden" animate="visible" exit="exit" data-id="element-788">
      <motion.h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-6" variants={slideUp} data-id="element-789">
        {language === 'en' ? 'Dashboard Overview' : 'نظرة عامة على لوحة التحكم'}
      </motion.h2>
      <LiveDashboard data-id="element-790" />
    </motion.div>;
};